import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import DatePick from 'vue-date-pick'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  name: 'HolidaysForm',
  computed,
  data,
  methods,
  mounted,
  components: {
    Cropper,
    DatePick
  }
}
